import { ApplicationTableData, UserData } from "app/models/admin.model";

export const MockApplicationData: ApplicationTableData[] = [
    { form : 'A', applicant: 'Doug Randolf', firstSuggestedName: 'Nefrostat', 
        date: '09/15/2024', negotiator: 'Sarah Johnson', status: 'In Review', progress: '50'},
    { form : 'C', applicant: 'Stuart Johnston', firstSuggestedName: 'Venlafaxine succinate', 
        date: '08/30/2024', negotiator: 'Emily Rodriguez', status: 'In Review', progress: '60'},
    { form : 'F', applicant: 'Patrick Deniro', firstSuggestedName: 'Zolimumab', 
        date: '09/28/2024', negotiator: 'Robert Lee', status: 'In Negotiation', progress: '85'},
    { form : 'D', applicant: 'Travis Swift', firstSuggestedName: 'Lumidex SR', 
        date: '09/30/2024', negotiator: 'Robert Lee', status: 'Payment Pending', progress: '25'}, 
];

export const MockAdminUserData: UserData[] = [
    { userName: 'Doug Randolf', accessType: 'Applicant', status: 'Active'},
    { userName: 'Stuart Johnston', accessType: 'Applicant', status: 'Pending'},
    { userName: 'Patrick Deniro', accessType: 'Viewer', status: 'Active'},
    { userName: 'Travisdssd Swiftdssdsdfs', accessType: 'Applicant', status: 'Active'}
]

export const MockSuggestedNames = 'Oxyflux,Hydraclear,Aquacomfort,Biofinity,Optisoft';

export const AccessTypesList = [
    { code:'Applicant', val:'USAN Applicant', desc:'USAN Applicant: USAN Applicants can start, edit and submit applications through the USAN portal as well as access all standard user features.'},
    { code:'User', val:'USAN User', desc: 'USAN User (View Only): USAN Users can only view applications, receive status update notifications, add comments, request payment information and upload supporting documents.'}
]

export const AccessTypesListAdmin = [
    { code:'Applicant', val:'USAN Applicant', desc:'USAN Applicant: USAN Applicants can start, edit and submit applications through the USAN portal as well as access all standard user features.'},
    { code:'User', val:'USAN User', desc: 'USAN User (View Only): USAN Users can only view applications, receive status update notifications, add comments, request payment information and upload supporting documents.'},
    { code:'Admin', val:'USAN Org Admin', desc: 'USAN Org Admin: USAN Org Admins can view applications, add comments, add users and modify their access.'}
]

export const MockUserData: UserData[] = [
    { userName: 'Doug Randolf', accessType: 'Applicant', status: 'Active', email: 'doug@mail.com', companyName:'ABC'},
    { userName: 'Stuart Johnston', accessType: 'Applicant', status: 'Pending', email: 'stuart@mail.com', companyName:'DEF'},
    { userName: 'Patrick Deniro', accessType: 'Viewer', status: 'Active', email: 'patrick@mail.com', companyName:'ABC'},
    { userName: 'Travis Swift', accessType: 'Applicant', status: 'Active', email: 'travis@mail.com', companyName:'DEF'}
]

export const MockNegotiatorData: UserData[] = [
    { userName: 'Doug Randolf', email: 'doug@mail.com', firstName: 'Doug', uniqueId: 'ABC'},
    { userName: 'Jack Smith', email: 'jack@mail.com', firstName: 'Jack', uniqueId: 'ABC'},
]